import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/eurodrive/components/AppInsights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/eurodrive/components/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadResources"] */ "/app/apps/eurodrive/components/PreloadResources.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryContext"] */ "/app/apps/eurodrive/components/ReactQueryContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/eurodrive/theme/ThemeProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/.pnpm/@apollo+client-react-streaming@0.11.7_@apollo+client@3.12.4_react@18.3.1/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.3_next@14.2.35_react@18.2.0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.3_next@14.2.35_react@18.2.0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.3_next@14.2.35_react@18.2.0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.4_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.4_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.4_react-dom@18.2.0_react@18.2.0/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Assistant\",\"arguments\":[{\"subsets\":[\"hebrew\",\"latin\"],\"display\":\"swap\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--assistant\",\"preload\":true}],\"variableName\":\"assistant\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/apollo/apollo-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/Articles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/BranchCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/CalculatorContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/CarImagePlaceholder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/CarsSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/ComparisonBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComparisonProvider","useComparison"] */ "/app/packages/ui/contexts/ComparisonContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomBreadcrumbs"] */ "/app/packages/ui/CustomBreadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/CustomHelperText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomCheckbox","CustomSelect","CustomTextField","MultilineCustomTextField"] */ "/app/packages/ui/form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/FormBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/layout/Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/Marketing.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/MediaQueries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/PreviouslyViewed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/ReasonsWhy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/ReCaptchaDisclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/Result.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/TextImageBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/theme/theme.ts");
;
import(/* webpackMode: "eager", webpackExports: ["TransitionRight"] */ "/app/packages/ui/transitions/TransitionRight.ts");
;
import(/* webpackMode: "eager", webpackExports: ["TransitionUp","TransitionUpComponent"] */ "/app/packages/ui/transitions/TransitionUp.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTransitionUpStyles"] */ "/app/packages/ui/transitions/useTransitionUpStyles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useLocalStorage"] */ "/app/packages/utils/useLocalStorage.ts");
;
import(/* webpackMode: "eager", webpackExports: ["usePreviouslyViewed"] */ "/app/packages/utils/usePreviouslyViewed.ts");
